import NoteEdit from '../../src/legacy/NoteEdit';
export default NoteEdit;
